import { render, staticRenderFns } from "./batch-budget.vue?vue&type=template&id=6196f972&scoped=true"
import script from "./batch-budget.vue?vue&type=script&lang=js"
export * from "./batch-budget.vue?vue&type=script&lang=js"
import style0 from "./batch-budget.vue?vue&type=style&index=0&id=6196f972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6196f972",
  null
  
)

export default component.exports